/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} People_InvitedInputs */

const en_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invited: <span style="__STYLE__">${i?.number}</span>`)
};

const ar_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`المدعوون: <span style="__STYLE__">${i?.number}</span>`)
};

const de_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Eingeladen: <span style="__STYLE__">${i?.number}</span>`)
};

const es_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitados: <span style="__STYLE__">${i?.number}</span>`)
};

const fr_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invités : <span style="__STYLE__">${i?.number}</span>`)
};

const it_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Invitati: <span style="__STYLE__">${i?.number}</span>`)
};

const ja_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`招待済み：<span style="__STYLE__">${i?.number}</span>人`)
};

const ko_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`초대됨: <span style="__STYLE__">${i?.number}</span>명`)
};

const pt_br_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Convidados: <span style="__STYLE__">${i?.number}</span>`)
};

const ru_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Приглашено: <span style="__STYLE__">${i?.number}</span>`)
};

const th_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เชิญแล้ว: <span style="__STYLE__">${i?.number}</span> คน`)
};

const tr_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Davet edilen: <span style="__STYLE__">${i?.number}</span>`)
};

const zh_cn_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已邀请 <span style="__STYLE__">${i?.number}</span> 人`)
};

const zh_tw_people_invited = /** @type {(inputs: People_InvitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已邀請 <span style="__STYLE__">${i?.number}</span> 人`)
};

/**
* | output |
* | --- |
* | "Invited: <span style=\"__STYLE__\">{number}</span>" |
*
* @param {People_InvitedInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const people_invited = /** @type {((inputs: People_InvitedInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<People_InvitedInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_people_invited(inputs)
	if (locale === "ar") return ar_people_invited(inputs)
	if (locale === "de") return de_people_invited(inputs)
	if (locale === "es") return es_people_invited(inputs)
	if (locale === "fr") return fr_people_invited(inputs)
	if (locale === "it") return it_people_invited(inputs)
	if (locale === "ja") return ja_people_invited(inputs)
	if (locale === "ko") return ko_people_invited(inputs)
	if (locale === "pt_br") return pt_br_people_invited(inputs)
	if (locale === "ru") return ru_people_invited(inputs)
	if (locale === "th") return th_people_invited(inputs)
	if (locale === "tr") return tr_people_invited(inputs)
	if (locale === "zh_cn") return zh_cn_people_invited(inputs)
	return zh_tw_people_invited(inputs)
});